import { render, staticRenderFns } from "./AuditsSkeleton.vue?vue&type=template&id=51a3046f&scoped=true&"
import script from "./AuditsSkeleton.vue?vue&type=script&lang=ts&"
export * from "./AuditsSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a3046f",
  null
  
)

export default component.exports